module.exports = __webpack_public_path__ + "img/img04.042f6dcb.png";